"use client";

import { useEffect, useState, ReactNode } from "react";
import { Provider } from "react-redux";
import { makeStore } from "@/app/store";
import { hydrate } from "@/app/store/cookieConsentSlice";
import { hydrate as hydrateTheme } from "@/app/store/themeSlice";
import { ThemeSync } from "./ThemeSync";

type StoreProviderProps = {
  children: ReactNode;
};

export function StoreProvider({ children }: StoreProviderProps) {
  const [store] = useState(() => makeStore());

  useEffect(() => {
    store.dispatch(hydrate());
    store.dispatch(hydrateTheme());
  }, [store]);

  return (
    <Provider store={store}>
      <ThemeSync />
      {children}
    </Provider>
  );
}
